import {css} from "lit";

// Note that we don't use variables in some places because these are external colors/styles.

export default [css`
	button {
		display: flex;
		width: 100%;
		gap: 8px;
		align-items: center;
		text-align: left;
		cursor: pointer;

		padding: 0.5rem;
		margin: 0;
		background: none;
		border: none;
	}

	img {
		width: 26px;
		height: 26px;
	}

	span {
		font-family: "Open Sans", sans-serif;
		font-size: 16px;
		font-weight: 400;
		color: black;
	}

	button:hover span, button:focus span, button:active span {
		text-decoration: underline;
	}
`];
